import { Users, Megaphone, Receipt, ShieldAlert } from 'lucide-react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { StatCard } from '@/components/dashboard/StatCard';
import { participationsTrend, fmt } from '@/lib/mockData';

const AdminDashboard = () => (
  <DashboardLayout
    role="admin"
    user={{ name: 'Équipe Winkô', subtitle: 'Super Admin', initials: 'WK' }}
  >
    <PageHeader title="Vue d'ensemble" subtitle="État global de la plateforme Winkô." />

    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        label="Utilisateurs"
        value={fmt.number(15240)}
        delta={{ value: '+1 240 cette semaine', positive: true }}
        icon={Users}
        accent="primary"
      />
      <StatCard
        label="Campagnes actives"
        value={8}
        delta={{ value: '+2 ce mois-ci', positive: true }}
        icon={Megaphone}
        accent="accent"
      />
      <StatCard
        label="Revenus mensuels"
        value="3,2 M FCFA"
        delta={{ value: '+18 % MoM', positive: true }}
        icon={Receipt}
        accent="emerald"
      />
      <StatCard label="En modération" value={3} icon={ShieldAlert} accent="amber" />
    </div>

    <div className="mt-8 rounded-2xl border border-border bg-card p-6 shadow-soft">
      <h3 className="font-display text-lg font-bold">Activité plateforme — 14 jours</h3>
      <div className="mt-4 h-72">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={participationsTrend}>
            <defs>
              <linearGradient id="adA" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity={0.4} />
                <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
            <XAxis
              dataKey="day"
              stroke="hsl(var(--muted-foreground))"
              fontSize={11}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              stroke="hsl(var(--muted-foreground))"
              fontSize={11}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip
              contentStyle={{
                background: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: 12,
                fontSize: 12,
              }}
            />
            <Area
              type="monotone"
              dataKey="participations"
              stroke="hsl(var(--primary))"
              strokeWidth={2}
              fill="url(#adA)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  </DashboardLayout>
);

export default AdminDashboard;
